import { Typography } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Props {
  label: string;
  /** If string → value displayed after label (e.g. "5 ta", "Cheksiz") */
  value?: string;
  /** If true → check icon. False → close icon (feature disabled) */
  enabled: boolean;
}

/**
 * Single feature row inside a plan card.
 * - 22px gradient ikon disk (yashil ✓ / kulrang ✗)
 * - Label + optional value
 * - Disabled holatda muted ranglar
 */
export default function FeatureCheckRow({ label, value, enabled }: Props) {
  const fg = enabled ? '#1f8b4c' : '#9ca3af';
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '5px 0',
      }}
    >
      <div
        aria-hidden
        style={{
          width: 22,
          height: 22,
          borderRadius: 7,
          background: enabled
            ? 'linear-gradient(135deg, rgba(31,139,76,0.14) 0%, rgba(31,139,76,0.28) 100%)'
            : 'var(--bl-muted-soft, #eef0f3)',
          border: enabled
            ? '1px solid rgba(31,139,76,0.22)'
            : '1px solid var(--bl-divider, #e5e7eb)',
          color: fg,
          fontSize: 10,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {enabled ? <CheckOutlined /> : <CloseOutlined />}
      </div>

      <Text
        style={{
          flex: 1,
          minWidth: 0,
          fontSize: 13,
          fontWeight: enabled ? 500 : 500,
          color: enabled
            ? 'var(--bl-text-strong, #0f172a)'
            : 'var(--bl-text-muted, #9ca3af)',
          lineHeight: 1.4,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
        {value !== undefined && (
          <>
            <span style={{ color: 'var(--bl-text-muted, #9ca3af)', margin: '0 4px' }}>·</span>
            <span
              style={{
                fontWeight: 700,
                color: enabled
                  ? 'var(--bl-text-strong, #0f172a)'
                  : 'var(--bl-text-muted, #9ca3af)',
              }}
            >
              {value}
            </span>
          </>
        )}
      </Text>
    </div>
  );
}
